import './css/main.css';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import Message from './common/message';

function Notice() {
    const dark = useSelector((state) => state.Darkmode.value);
    const darkname = dark ? "dark" : "";

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // ========== Popup 관련 상태 ==========
    const [popupData, setPopupData] = useState([]);

    // 이미지 관련
    const [popupImage, setPopupImage] = useState(null);
    const [originalPopupImage, setOriginalPopupImage] = useState(null);
    const [popupFile, setPopupFile] = useState(null);

    // 활성화(Active) 관련
    const [popupActive, setPopupActive] = useState("Y");
    const [originalActive, setOriginalActive] = useState("Y");

    // 새로고침 트리거
    const [reload, setReload] = useState(false);

    // ========== 데이터 조회 ==========
    useEffect(() => {
        getPopupData();
    }, [reload]);

    const getPopupData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/popup");
            const tmp = response?.data;
            console.log("getPopupData:", tmp);

            // 기존 데이터가 존재하는 경우
            if (tmp?.code === 1000 && tmp?.data?.popup?.[0]) {
                const popupObj = tmp.data.popup[0];

                // 서버에서 가져온 값으로 state 초기화
                setPopupData(popupObj);
                setPopupImage(popupObj.popupUrl ?? "");
                setOriginalPopupImage(popupObj.popupUrl ?? "");

                // 활성화 값도 서버 값 그대로 반영
                if (popupObj.active) {
                    setPopupActive(popupObj.active);
                    setOriginalActive(popupObj.active);
                }

                // ★ 파일 상태를 초기화 (등록/수정 후 재조회 시 수정 상태 풀기 위함)
                setPopupFile(null);
            } else {
                // 만약 DB에 데이터가 없는 경우 처리
                setPopupData([]);
                setPopupImage(null);
                setOriginalPopupImage(null);
                setPopupFile(null);
                setPopupActive("Y");
                setOriginalActive("Y");
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ========== 파일 선택 시 처리 (미리보기 + File객체 세팅) ==========
    const handleFileChange = (file, setImage, setFile) => {
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
            setFile(file);
        }
    };

    // ========== 취소 처리 (이미지/active 원상복구, File 객체 초기화) ==========
    const handleCancelAll = () => {
        setPopupImage(originalPopupImage);
        setPopupFile(null);
        setPopupActive(originalActive);
    };

    // ========== 팝업 이미지 등록 (POST) ==========
    const handlePopupAdd = async (file) => {
        if (!file) {
            alert("이미지를 선택하세요.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("active", popupActive);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/popup",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                // 등록 성공 후 데이터 재조회
                setReload((prev) => !prev);
            } else {
                alert("업로드 실패");
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ========== 팝업 이미지 수정 (POST) ==========
    const handlePopupUpdate = async (file, id) => {
        if (!file && popupActive === originalActive) {
            alert("변경사항이 없습니다.");
            return;
        }

        const formData = new FormData();
        formData.append("id", id);
        formData.append("active", popupActive);

        if (file) {
            formData.append("file", file);
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/popup/update",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((prev) => !prev);
            } else {
                alert("업로드 실패");
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ========== 팝업 이미지 삭제 (POST) ==========
    const handlePopupDelete = async (id) => {
        if (!window.confirm("정말로 삭제하시겠습니까?")) return;

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/popup/delete",
                { id: id }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((prev) => !prev);
            } else {
                alert("삭제 실패");
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ========== 업로드 영역 컴포넌트 ==========
    const UploadArea = ({
        image,
        setImage,
        label,
        originalImage,
        file,
        setFile,
        id,
        popupActive,
        setPopupActive,
        originalActive
    }) => {
        const [isDragging, setIsDragging] = useState(false);

        const hasImage = !!originalImage;
        const activeChanged = popupActive !== originalActive;
        const fileChanged = file !== null;

        // 둘 중 하나라도 달라지면 수정 상태
        const isModified = activeChanged || fileChanged;

        // 드롭 이벤트
        const handleDrop = (e) => {
            e.preventDefault();
            const droppedFile = e.dataTransfer.files[0];
            handleFileChange(droppedFile, setImage, setFile);
            setIsDragging(false);
        };

        return (
            <div>
                {/* 이미지 업로드 영역 */}
                <div
                    className={`upload-area ${darkname}`}
                    style={{
                        width: "350px",
                        height: "700px",
                        border: isDragging ? "2px solid #2196F3" : "2px dashed #ccc",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        backgroundColor: isDragging
                            ? "rgba(33, 150, 243, 0.1)"
                            : image
                                ? "#f8f8f8"
                                : "transparent",
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                    }}
                    onDragOver={(e) => {
                        e.preventDefault();
                        setIsDragging(true);
                    }}
                    onDragEnter={(e) => {
                        e.preventDefault();
                        setIsDragging(true);
                    }}
                    onDragLeave={(e) => {
                        e.preventDefault();
                        setIsDragging(false);
                    }}
                    onDrop={handleDrop}
                >
                    {image ? (
                        <img
                            src={image}
                            alt={`${label} 미리보기`}
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                        />
                    ) : (
                        <div
                            style={{
                                color: isDragging ? "#2196F3" : "#888",
                                textAlign: "center",
                            }}
                        >
                            {isDragging
                                ? "드롭하세요!"
                                : "이미지를 드래그하거나 클릭하여 업로드하세요"}
                        </div>
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e.target.files[0], setImage, setFile)}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                        }}
                    />
                </div>

                {/* 활성화/비활성화 선택 박스 */}
                <div style={{ margin: "10px" }}>
                    <label style={{ marginRight: "10px" }}>활성화 설정:</label>
                    <select
                        value={popupActive}
                        onChange={(e) => setPopupActive(e.target.value)}
                        style={{ padding: '5px', border: "1px solid gray", borderRadius: "5px" }}
                    >
                        <option value="Y">활성화</option>
                        <option value="N">비활성화</option>
                    </select>
                </div>

                {/* 조건별 버튼 */}
                <div className="modal-btn-box" style={{ marginTop: "20px" }}>
                    {/* 1) DB에 이미지 없음 + 변경사항 없음 => 버튼 없음 */}
                    {!hasImage && !isModified && <></>}

                    {/* 2) DB에 이미지 없음 + 변경사항 있음 => [등록, 취소] */}
                    {!hasImage && isModified && (
                        <>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handlePopupAdd(file)}
                            >
                                등록
                            </div>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handleCancelAll()}
                            >
                                취소
                            </div>
                        </>
                    )}

                    {/* 3) DB에 이미지 있음 + 변경사항 없음 => [삭제] */}
                    {hasImage && !isModified && (
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => handlePopupDelete(id)}
                        >
                            삭제
                        </div>
                    )}

                    {/* 4) DB에 이미지 있음 + 변경사항 있음 => [저장, 취소] */}
                    {hasImage && isModified && (
                        <>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handlePopupUpdate(file, id)}
                            >
                                저장
                            </div>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handleCancelAll()}
                            >
                                취소
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="main">
            <div className={`main-box ${darkname}`} style={{ display: "flex", gap: "50px" }}>
                <div>
                    <div className="maintab">
                        <div className={`maintab-btn on ${darkname}`}>팝업 이미지</div>
                    </div>
                    <UploadArea
                        image={popupImage}
                        setImage={setPopupImage}
                        label="팝업 이미지"
                        originalImage={originalPopupImage}
                        file={popupFile}
                        setFile={setPopupFile}
                        id={popupData?.id}
                        popupActive={popupActive}
                        setPopupActive={setPopupActive}
                        originalActive={originalActive}
                    />
                </div>
            </div>
        </div>
    );
}

export default Notice;
